var map = {
	"./admin/admin.module": [
		"../../../../../client/app/admin/admin.module.ts",
		"admin.module",
		"common"
	],
	"./alert/alert.module": [
		"../../../../../client/app/alert/alert.module.ts",
		"alert.module"
	],
	"./citizen/citizen.module": [
		"../../../../../client/app/citizen/citizen.module.ts",
		"citizen.module",
		"common"
	],
	"./citpermit/citpermit.module": [
		"../../../../../client/app/citpermit/citpermit.module.ts",
		"citpermit.module",
		"common"
	],
	"./home/home.module": [
		"../../../../../client/app/home/home.module.ts",
		"common",
		"home.module"
	],
	"./map/map.module": [
		"../../../../../client/app/map/map.module.ts",
		"map.module"
	],
	"./others/others.module": [
		"../../../../../client/app/others/others.module.ts",
		"others.module"
	],
	"./pawn/pawn.module": [
		"../../../../../client/app/pawn/pawn.module.ts",
		"pawn.module",
		"common"
	],
	"./payment/payment.module": [
		"../../../../../client/app/payment/payment.module.ts",
		"payment.module",
		"common"
	],
	"./permit/permit.module": [
		"../../../../../client/app/permit/permit.module.ts",
		"permit.module",
		"common"
	],
	"./report/report.module": [
		"../../../../../client/app/report/report.module.ts",
		"report.module",
		"common"
	],
	"./services/service.module": [
		"../../../../../client/app/services/service.module.ts",
		"service.module",
		"common"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = "../../../../../client/$$_gendir lazy recursive";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/$$_gendir lazy
// module id = ../../../../../client/$$_gendir lazy recursive
// module chunks = main